import moment from 'moment';
import React from 'react'

function formatDate(date) {
    return moment(Number(date)).format('D MMM \YY [at] h:mm A');
}

export default formatDate